import { render } from "./CreatePlaceholder.vue?vue&type=template&id=dcfdbad4&scoped=true&ts=true"
import script from "./CreatePlaceholder.vue?vue&type=script&lang=ts"
export * from "./CreatePlaceholder.vue?vue&type=script&lang=ts"

import "./CreatePlaceholder.vue?vue&type=style&index=0&id=dcfdbad4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcfdbad4"]])

export default __exports__